import React, { FC, useMemo } from 'react';
import clsx from 'clsx';
import { Typography, Icon } from '@npm-registry/eapteka-ui';
import {
  IconNameMedium,
  IconNameSmall
} from '@npm-registry/eapteka-ui/lib/components/Icon/icons';
import { formatIcon } from '../../../helpers/formatIcon';
import { SaleProps } from './types';
import styles from './Sale.scss';

export const Sale: FC<SaleProps> = ({
  className,
  icon = 'saleRound',
  iconColor = '#f8a100',
  title
}) => {
  const iconName = useMemo(
    () => formatIcon(icon),
    [icon]
  ) as IconNameMedium | IconNameSmall;
  const style = useMemo(
    () => ({
      color: iconColor
    }),
    [iconColor]
  );

  return (
    <div
      className={clsx([styles.root, className])}
      title={title}
    >
      {iconName && (
        <Icon
          className={styles.icon}
          style={style}
          name={iconName}
        />
      )}
      <Typography className={styles.title} variant="p2">
        {title}
      </Typography>
    </div>
  );
};
